import { SxProps, Theme } from '@mui/material';

export const stylesSubscribeFormGridContainer: SxProps<Theme> = {
  height: '100%',
};

export const stylesSubscribeGridItem: SxProps<Theme> = {
  height: '100%',
};

export const stylesSubscribeCard: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const stylesSubscribeCardSubheader: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  mt: 2,
};

export const stylesSubscribeCardContent: SxProps<Theme> = {
  flex: 1,
  overflow: 'auto',
};

export const stylesSubscribeFormSubtitle: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  color: 'primary.main',
  pb: 2,
};

export const stylesAutoCompleteSingleSelect = {
  '&.MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
    padding: '0px !important',
  },
};
